import React from 'react';
import {
  Form,
  Checkbox,
  Divider,
  Radio,
  Select,
  Menu,
  Dropdown,
  Icon,
  Input,
  InputNumber,
} from 'antd';

import FieldUpload from './FieldUpload'

class ClientInvoicingInformation extends React.Component {
  render() {
    return (
      <Form name="client-invoicing-information">
        <h3 className="fluid-field">
          Information below will be copied to the invoice when you issue invoice
          for this assessment.
        </h3>
        <div className="fluid-field checkbox-field">
          <Checkbox>
            All information is accurate and complete, ready for invoice creation
          </Checkbox>
        </div>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">Service Notes</h3>
        <div className="fluid-field checkbox-field">
          <Checkbox>Urgent Report</Checkbox>
          <Checkbox> 20 pages</Checkbox>
        </div>
        <Form.Item label="Interpreter Required">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Organised by Operator">
          <Radio.Group>
            <Radio>Yes</Radio>
            <Radio>No</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Language">
          <Select size="large" value="1">
            <Select.Option value="1">Option</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Interpreter Specialist">
          <Select size="large" value="1">
            <Select.Option value="1">Option</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Dictation and Report Typing by">
          <Radio.Group>
            <Radio>ICS</Radio>
            <Radio>Non-ICS</Radio>
            <Radio>Not sure</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Medical Practice Type">
          <Radio.Group>
            <Radio>ICS Clinic</Radio>
            <Radio>Doctor's External Clinic</Radio>
            <Radio>Obtained Appt</Radio>
            <Radio>Home Visit</Radio>
          </Radio.Group>
        </Form.Item>

        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">
          Client Invoicing Information
        </h3>
        <Form.Item label="Paying Client">
          <Select size="large" value="1">
            <Select.Option value="1">Option</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="C/-Reference">
          <Select size="large" value="1">
            <Select.Option value="1">Option</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          required
          label={
            <React.Fragment>
              Case Manager / Solicitor
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item>Add Case Manager</Menu.Item>
                    <Menu.Item>Edit Case Manager</Menu.Item>
                  </Menu>
                }
              >
                <button className="field-actions">
                  Add/Edit <Icon type="down" />
                </button>
              </Dropdown>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">No. 2767 3M</Select.Option>
          </Select>
        </Form.Item>
        <div />
        <Form.Item label="Email For Sending Invoices 1">
          <Input size="large" />
          <Checkbox style={{ marginTop: 10 }}>Send to Booking CM</Checkbox>
        </Form.Item>
        <Form.Item label="Email For Sending Invoices 2">
          <Input size="large" />
          <Checkbox style={{ marginTop: 10 }}>
            Same As Client’s Accounting Email
          </Checkbox>
        </Form.Item>
        <Form.Item label="Billing Item Codes">
          <Input size="large" />
          <Checkbox style={{ marginTop: 10 }}>Doctor Service</Checkbox>
        </Form.Item>
        <div />
        <Form.Item label="Billing Item Fees (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GST">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Admin Extra (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
          <Checkbox style={{ marginTop: 10 }}>Doctor Service</Checkbox>
        </Form.Item>
        <Form.Item label="GST">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Other Fees (excl GST)</Checkbox>
        </div>
        <Form.Item label="Fee Name">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="Fee">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GTS">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
          <Checkbox style={{ marginTop: 10 }}>Doctor Service</Checkbox>
        </Form.Item>
        <div />
        <Form.Item className="fluid-field" label="Fee 1 Description">
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item label="MAG Service Fees (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GTS">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item className="fluid-field" label="Description">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <Form.Item label="Total Billing Amount (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Total GST">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Total Billing Amount (incl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item className="fluid-field" label="Description">
          <Input.TextArea rows={6} />
        </Form.Item>

        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attach Client Files"
        />
        <Divider className="fluid-field" />
        <h3 className="form-subtitle fluid-field">
          Specialist Billing Information
        </h3>
        <Form.Item label="Service Amount (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GST">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Service Amount (incl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Booking Fee Type">
          <Radio.Group>
            <Radio>MAG</Radio>
            <Radio>Non-MAG</Radio>
            <Radio>Gross Margin COT</Radio>
            <Radio>Fixed Amount</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          required
          label={
            <React.Fragment>
              Commission Rate (%)
              <button className="field-actions">Check Current Rate</button>
            </React.Fragment>
          }
        >
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Eligible Service Amount (excl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="GTS">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
        <Form.Item label="Eligible Service Amount (incl GST)">
          <InputNumber
            size="large"
            formatter={value =>
              `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
            parser={value => value.replace(/\$\s?|(,*)/g, '')}
          />
        </Form.Item>
      </Form>
    );
  }
}

export default ClientInvoicingInformation;
